<router-outlet></router-outlet> <ngx-spinner size="medium" color="var(--kcs-primary)" bdColor="rgba(0, 0, 0, 0.3)" name="app" type="ball-clip-rotate"></ngx-spinner>
<app-custom-toast></app-custom-toast>
@if (showEnvBadge) {
	<div class="env-badge" [class.env-badge--test]="isEnvTest" [class.env-badge--dev]="!isEnvTest" aria-hidden="true">
		<span class="env-badge__text">{{ envLabel }}</span>
	</div>
}
